import { makeStyles } from '@material-ui/core/styles'
import { isDarkColor } from '@v4/utils'
import { dark, light } from '@material-ui/core/esm/styles/createPalette'

const useStyles = makeStyles(
	theme => {
		const color = theme.palette.calcContrastColor(dark.text.secondary, theme.palette.background.default)
		const borderColor = theme.palette.calcContrastColor(
			theme.palette.text.secondary,
			theme.palette.background.default,
		)
		return {
			root: {
				alignItems: ({ justify }) => justify,
				display: 'flex',
				flexDirection: 'column',
				'& $notchedOutline': {
					borderColor,
					borderWidth: '2px !important',
				},
				'& $textarea': {
					padding: 10.5,
					lineHeight: 1.5,
					borderRadius: theme.spacing(1),
					color: ({ withBgImage }) => (withBgImage ? light.text.primary : color),
					'&:hover': {
						'& $notchedOutline': {
							borderColor,
						},
					},
				},

				'& $multiline': {
					padding: 0,
				},
			},
			field: {
				background: ({ withBgImage }) => (withBgImage ? theme.palette.common.white : 'transparent'),

				// eslint-disable-next-line max-len
				'& input:-webkit-autofill,& input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
					WebkitBoxShadow: ({ withBgImage }) =>
						`0 0 0 5000px ${
							withBgImage ? theme.palette.common.white : theme.palette.background.default
						} inset !important`,
					WebkitTextFillColor: ({ withBgImage }) => (withBgImage ? light.text.primary : color),
				},
			},
			fullWidth: {
				'& $content': {
					display: 'flex',
					width: '100%',
				},
				'& $row': {
					justifyContent: 'space-between',
				},
			},
			input: {
				borderRadius: theme.spacing(1),
				height: theme.spacing(5.75),
				boxSizing: 'border-box',
				color: ({ withBgImage }) => (withBgImage ? light.text.primary : color),
				'&:hover': {
					'& $notchedOutline': {
						borderColor,
					},
				},
				'&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
					'-webkit-appearance': 'none',
					margin: 0,
				},
				'&[type=number]': {
					'-moz-appearance': 'textfield',
				},
			},
			notchedOutline: {},
			error: {
				color: theme.palette.error.main,
				'&:hover': {
					'& $notchedOutline': {
						borderColor,
					},
				},
			},
			textarea: {},
			multiline: {},

			amount: {
				display: 'flex',
				justifyContent: 'flex-end',
				paddingTop: theme.spacing(1),
				color: theme.palette.text.secondary,
			},

			content: {
				display: 'inline-flex',
				flexDirection: 'column',
				width: '100%',
			},

			row: {
				display: 'flex',
				maxWidth: '100%',
				flexWrap: 'nowrap',
				justifyContent: ({ justify }) => justify,
				alignItems: ({ justify }) => justify,
			},
			control: {
				maxWidth: theme.spacing(8),
				margin: 0,
				'& input:focus ~ div svg:first-child path': {
					stroke: isDarkColor(theme.palette.primary.main)
						? theme.palette.primary.light
						: theme.palette.primary.dark,
					strokeWidth: 1,
				},
			},
		}
	},
	{ name: 'Questions-InputField' },
)

export default useStyles
